import { render, staticRenderFns } from "./phone-follow-query.vue?vue&type=template&id=d807ca78"
import script from "./phone-follow-query.vue?vue&type=script&lang=ts"
export * from "./phone-follow-query.vue?vue&type=script&lang=ts"
import style0 from "./phone-follow-query.vue?vue&type=style&index=0&id=d807ca78&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports